// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"7538":"recorder","9983":"profiler"}[chunkId] || chunkId) + "." + {"641":"0d010b6ad2d1fb3e","3240":"4d094dfc6f57e74d","7538":"dd8def6311bf8ab3","9983":"f9029542c9548517"}[chunkId] + ".js";
};